<template>
  <div class="contacts-sidebar">
    <ContactListFilter v-on:filterCompanies="filterContacts" />

    <form @submit.prevent class="search-contacts">
      <search-icon />

      <input
        :value="crmContactsSearch"
        @input="updateCrmContactsSearch($event.target.value)"
        type="text"
        placeholder="Pesquisar Contato"
      />

      <div class="dropdown dropleft">
        <a href="#" class="dd-link" data-toggle="dropdown">
          <div>
            <!-- <i class="fa fa-angle-left mg-r-10"></i> -->
            <i class="icon ion-more mg-r-10 tx-30"></i>
            <!-- <span>AÇÕES</span> -->
          </div>
        </a>
        <div class="dropdown-menu wd-300 pd-5">
          <nav class="nav dropdown-nav">
            <a
              href="#"
              class="nav-link"
              @click.prevent="$router.push({ name: 'CrmAddContact' })"
              ><i class="icon ion-ios-person"></i> Adicionar Contato</a
            >
            <a
              href="#"
              class="nav-link"
              @click.prevent="$router.push({ name: 'CrmAddCustomer' })"
              ><i class="icon ion-ios-briefcase"></i> Adicionar Empresa</a
            >
          </nav>
        </div>
      </div>
    </form>
    <div class="contacts-list">
      <ul class="contacts-letters">
        <li v-for="letter in alphabet" :key="letter">
          <a @click.prevent="goToLetter(letter)" href="#">{{ letter }}</a>
        </li>
      </ul>
      <!-- {{ orderedContacts }} -->
      <ul class="contacts" ref="contactList">
        <div v-for="(contacts, index) in orderedContacts" :key="index">
          <!-- {{ contact[0] }} -->
          <li
            class="contact-letter-separator"
            :data-letter="contacts[0].name.split('')[0].toUpperCase()"
          >
            <span>{{ contacts[0].name.split("")[0].toUpperCase() }}</span>
          </li>
          <li
            v-for="contact in contacts"
            :key="contact.id"
            @click.prevent="openContact(contact.id)"
            :class="[
              'contact-item',
              contact.id == $route.params.id ? ' active' : '',
            ]"
          >
            <span class="contact-letter">{{
              getFirstLetter(contact.name)
            }}</span>
            <div class="contact-content">
              <span class="name">{{ contact.name.slice(0, 23) }}</span>
              <span class="email">{{
                contact.email1 ? contact.email1 : contact.email2
              }}</span>
              <span class="email"
                >{{ contact.city ? contact.city.toUpperCase() : "" }}
                {{
                  contact.federalUnity
                    ? "/ " + contact.federalUnity.toUpperCase()
                    : ""
                }}</span
              >
              <div
                v-popover.right="{ name: 'popover-companies' }"
                v-if="contact.companiesCount > 0"
              >
                <span v-if="contact.companiesCount === 0" class="mt-2"
                  >Nenhum vinculo com empresas</span
                >
                <a
                  v-else
                  href="#"
                  @click.prevent="getCompanies(contact.id, contact.name)"
                >
                  <i class="fa fa-building mt-2"></i>
                  {{ getCountCompaniesTextValue(contact.companiesCount) }}
                </a>
                <transition name="fade">
                  <popover name="popover-companies" :width="340">
                    <div class="popover-content">
                      <span v-if="inLoadCompanies">Carregando...</span>
                      <div v-else>
                        <h5>Empresas de {{ contactName }}</h5>
                        <ul>
                          <li
                            v-for="company in contactCompanies"
                            :key="company.id"
                          >
                            {{ company.completeName }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </popover>
                </transition>
              </div>
            </div>
            <div
              class="contact-birthday"
              v-if="
                contact.dateOfBirth &&
                checkBirthday(contact.dateOfBirth).birthday === true
              "
            >
              <cake-icon color="#80B7E2" :size="36" />
            </div>
            <div
              class="contact-birthday"
              v-if="
                contact.openingDate &&
                checkBirthday(contact.openingDate).birthday === true
              "
            >
              <cake-icon color="#80B7E2" :size="36" />
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import config from "@/config.js";
import Swal from "sweetalert2";
import Axios from "axios";
import { CakeIcon, SearchIcon } from "@/components/crm/Icons";
import { mapState, mapActions } from "vuex";
import ContactListFilter from "@/components/crm/ContactListFilter";

export default {
  name: "ContactList",
  components: {
    ContactListFilter,
    // Icons
    CakeIcon,
    SearchIcon,
  },
  data() {
    return {
      alphabet: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      contacts: [],
      contactCompanies: [],
      inLoadCompanies: false,
      contactName: "",
    };
  },
  async created() {
    await this.getContacts();
  },
  methods: {
    ...mapActions(["updateContactsList", "updateCrmContactsSearch"]),
    openContact(id) {
      this.$router.push({ name: "CrmContact", params: { id } });
    },
    async getCompanies(contactId, name) {
      this.inLoadCompanies = true;
      this.contactName = name;

      try {
        const response = await Axios.get(
          `${config.env.API_DEFAULT.host}/contactData/getCompanies/${contactId}`
        );
        this.contactCompanies = response.data.data;

        this.inLoadCompanies = false;
      } catch (error) {
        Swal.fire({
          title: "Carregar empresas",
          html: `<p>Não foi possível recuperar as empresas</p> <div>${error}</div>`,
          type: "error",
        });

        this.inLoadCompanies = false;
      }
    },
    async getContacts() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Carregando...",
        description: "Recuperando contatos.",
      });

      if (this.crmContactsFilters) {
        await this.filterContacts();
        this.getSidebarPosition();
      } else {
        try {
          const response = await Axios.get(
            `${
              config.env.API_DEFAULT.host
              // "/users/search/findByArchived?archive=false"
            }/contactData/listAllActives`
          );

          if (response) {
            this.updateContactsList(response.data.data);
            this.$store.commit("setLoading", { show: false });
            this.getSidebarPosition();
          }
        } catch (error) {
          Swal.fire({
            title: "Listagem de Contatos",
            html: "<p>Não foi possível recuperar os contatos</p>",
            type: "error",
          });
          this.$store.commit("setLoading", {
            show: false,
          });
        }
      }
    },
    getCountCompaniesTextValue(count) {
      if (count === 0) {
        return "Nenhum Empresa vinculáda";
      }

      if (count > 1) {
        return `${count} empresas vinculadas`;
      }

      return "1 Empresa vinculada";
    },

    getSidebarPosition() {
      const active = document.querySelector(".contacts li.active");
      const list = this.$refs.contactList;

      if (active) {
        list.scrollTo({
          top: active.offsetTop - 400,
        });
      }
    },

    async filterContacts() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Carregando...",
        description: "Recuperando clientes.",
      });

      try {
        const params = {};
        for (
          let i = 0;
          i < Object.entries(this.crmContactsFilters).length;
          i += 1
        ) {
          const item = Object.entries(this.crmContactsFilters)[i];
          const key = item[0];

          if (item[1]) {
            if (typeof item[1] === "object" && item[1].length > 0) {
              params[key] = item[1].join(",");
            } else {
              params[key] = item[1];
            }
          }
        }

        const response = await Axios.get(
          `${config.env.API_DEFAULT.host}/contactData/findAllByFiltersForContactList`,
          { params }
        );
        this.updateContactsList(response.data.data);
      } catch (e) {
        Swal.fire({
          title: "Relatório de contatos",
          message: `Houve um erro interno ao filtrar as empresas! ${e}`,
          type: "error",
        });
      }

      this.$store.commit("setLoading", {
        show: false,
      });
    },
    getFirstLetter(name) {
      return name.split("")[0];
    },
    goToLetter(letter) {
      const letterItem = this.$refs.contactList.querySelector(
        `li[data-letter="${letter}"]`
      );
      if (letterItem) {
        const scrollTop =
          letterItem.offsetTop - this.$refs.contactList.offsetTop;

        this.$refs.contactList.scroll({
          behavior: "smooth",
          top: scrollTop,
        });
      }
    },
    checkBirthday(date) {
      const today = moment();
      const birth = moment(date);

      if (birth.isValid()) {
        if (today.month() == birth.month() && today.date() == birth.date()) {
          return {
            birthday: true,
            years: today.diff(birth, "years"),
          };
        }
      }

      return {
        birthday: false,
      };
    },
  },
  computed: {
    ...mapState(["contactsList", "crmContactsFilters", "crmContactsSearch"]),
    orderedContacts() {
      let orderedContacts = this.contactsList;

      if (this.crmContactsSearch !== "") {
        orderedContacts = orderedContacts.filter((contact) => {
          const name = contact.name.toLowerCase();
          const email = contact.email1.toLowerCase();
          const reg = new RegExp(this.crmContactsSearch, "gi");

          if (reg.test(name) || reg.test(email)) {
            return contact;
          }
          return false;
        });
      }

      const grouped = orderedContacts.reduce((rv, x) => {
        (rv[x.name.split("")[0]] = rv[x.name.split("")[0]] || []).push(x);
        return rv;
      }, {});
      return grouped;
    },
  },
};
</script>

<style scoped>
.contacts-list {
  display: flex;
  overflow: auto;
  height: calc(100% - 108px);
}

.contacts-letters {
  flex: 0 0 45px;
  width: 45px;
  padding: 0;
  margin: 0;
  list-style: none;
  border-right: 1px solid #dee2e6;
  height: 100%;
  overflow: auto;
  scrollbar-color: #868ba1 transparent;
  scrollbar-width: thin;
}

.contacts-letters::-webkit-scrollbar {
  width: 4px;
  background-color: transparent;
}

.contacts-letters::-webkit-scrollbar-thumb {
  background-color: #868ba1;
  border-radius: 4px;
}

.contacts-letters li:not(:last-of-type) {
  border-bottom: 1px solid #dee2e6;
}

.contacts-letters li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background-color: white;
  color: #868ba1;
}

.contacts-letters li a:hover {
  background-color: #f8f9fa;
}

.contacts {
  padding: 0 10px;
  margin: 0;
  list-style: none;
  flex: 1 1 auto;
  overflow: auto;
  height: 100%;
  scrollbar-color: #868ba1 transparent;
  scrollbar-width: thin;
  scroll-behavior: smooth;
}

.contacts::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}

.contacts::-webkit-scrollbar-thumb {
  background-color: #868ba1;
  border-radius: 4px;
}

.contact-letter-separator {
  position: relative;
  padding: 10px 0;
}

.contact-letter-separator span {
  display: inline-block;
  background-color: white;
  padding: 0 10px 0 20px;
  position: relative;
}

.contact-letter-separator::before {
  content: "";
  display: block;
  position: absolute;
  inset: 0;
  margin: auto 0;
  width: 100%;
  height: 1px;
  background-color: #dee2e6;
}

.contact-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}

.contact-item:hover,
.contact-item.active {
  background-color: #8392a51a;
}

.contact-item .contact-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1b84e7;
  color: white;
  flex: 0 0 35px;
  width: 35px;
  height: 35px;
  border-radius: 70px;
}

.contact-content {
  flex: 1 1 auto;
  line-height: 1.2;
}

.contact-content span {
  display: block;
  overflow: hidden;
  max-width: 200px;
  text-overflow: ellipsis;
}

.contact-content .name {
  font-weight: bold;
  color: black;
  font-size: 1rem;
}

.vue-popover {
  z-index: 9000 !important;
  border: 1px solid #d7d7d7;
  box-shadow: unset !important;
  padding: 0;
  transform: translate3d(-80px, 0, 0);
}

.popover-content {
  padding: 10px;
  max-height: 150px;
  overflow-y: auto;
}

.popover-content h5 {
  color: black;
}

.popover-content ul {
  list-style: none;
  padding-left: 0;
  line-height: 1.4;
}

.popover-content ul li::before {
  content: "•";
  display: inline;
  margin-right: 5px;
}

.vue-popover::before {
  top: 15px !important;
  filter: unset !important;
  border-right: 6px solid #d7d7d7 !important;
}
</style>
